module.exports = __webpack_public_path__ + "static/media/bg@3x.ed1ec615.png";